<!-- SiPMMetxGHfC -->
<template>
	<div class="tabExport">
		<div class="exportControls">
			<el-radio-group v-model="exportMode" size="small" style="margin-right: 20px;" @change="dateSelected = ''">
				<el-radio-button label="week">Semaine</el-radio-button>
				<el-radio-button label="month">Mois</el-radio-button>
			</el-radio-group>
			<el-select v-model="dateSelected" :placeholder="exportMode === 'week' ? 'Choisir la semaine' : 'Choisir le mois'" clearable>
				<el-option v-for="item in periods" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-button @click.native.prevent="generateCsvFile(dateSelected)" type="warning" size="small" class="btnGenerateCsv">
				<i class="fas fa-file-csv iconOperationCsv"> Générer le .CSV</i>
			</el-button>
		</div>
		<el-table v-loading="loading" :data="tableExport">
			<el-table-column fixed label="#" width="90">
				<template slot-scope="scope">
					{{ ((scope.$index+1)+(currentPage-1)*10) }}
				</template>
			</el-table-column>
			<el-table-column label="Période">
				<template slot-scope="scope">
					<span v-if="scope.row.mode === 'month'">
						{{ scope.row.year + " / mois " + scope.row.period }}
					</span>
					<span v-else>
						{{ scope.row.year + " semaine " + scope.row.period }}
					</span>
				</template>
			</el-table-column>
			<el-table-column label="Nom du fichier">
				<template slot-scope="scope">{{ scope.row.name }}</template>
			</el-table-column>
			<el-table-column label="Nb écriture">
				<template slot-scope="scope">{{ scope.row.lines }}</template>
			</el-table-column>
			<el-table-column label="Généré le">
				<template slot-scope="scope">{{ getDateTime(scope.row.generated) }}</template>
			</el-table-column>
			<el-table-column fixed="right" label="Opérations" width="120">
				<template slot-scope="scope">
					<a :href="'/api/downloadExportVenteSage/'+scope.row.name" download>
						<i class="fas fa-file-download iconOperationDownload"></i>
					</a>
					<el-button @click.native.prevent="deleteRow(scope.row.name)" type="text" size="small">
						<i class="far fa-trash-alt iconOperationDelete"></i>
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination layout="prev, pager, next" :page-size="10" :total="dataExportLength" :current-page.sync="currentPage"></el-pagination>
	</div>
</template>

<script>
var moment = require('moment');
import script from '../../../../script/script.js';
import scriptComptabilite from '../../../../script/script_comptabilite';
export default {
	data () {
		return {
			dateSelected:'',
			exportMode: 'week',
			dataExport:[],
			dataExportPc:[],
			currentPage: 1,
			dataExportLength:null,
			loading:true
		}
	},
	methods: {
		getExportVenteSage: scriptComptabilite.getExportVenteSage,
		delExportVenteSage: scriptComptabilite.delExportVenteSage,
		getExportPcSage: scriptComptabilite.getExportPcSage,
		delExportPcSage: scriptComptabilite.delExportPcSage,
		generateCsv: scriptComptabilite.generateCsv,
		async generateCsvFile(date){
			if(!date) return
			this.loading = true
			await this.generateCsv(date, this.exportMode)
			this.getExportVenteSage('export','.txt')
			this.getExportPcSage('export/vente/pc','.txt')
			this.loading = false
		},
		async deleteRow(name) {
			await this.delExportVenteSage(name)
			this.getExportVenteSage('export','.txt')
		},
		async deleteRowPc(name) {
			await this.delExportPcSage(name)
			this.getExportPcSage('export/vente/pc','.txt')
		},
		getStartDateWeek(i){
			let startDate = null
			let j = 1
			var find = false
			while (!find) {
				if(moment().subtract(i,'w').week() != moment().subtract(i,'w').subtract(j,'d').week()){
					startDate = moment().subtract(i,'w').subtract(j-1,'d').startOf('day')
					find=true
				}else{
					j++
				}
			}
			return startDate
		},
		getEndDateWeek(i){
			let endDate = null
			let k = 1
			var find = false
			while (!find){
				if(moment().subtract(i,'w').week() != moment().subtract(i,'w').add(k,'d').week()){
					endDate = moment().subtract(i,'w').add(k-1,'d').startOf('day')
					find=true
				}else{
					k++
				}
			}
			return endDate
		},
		getDateTime(tms){
			var date = moment.unix(tms)
			return date.format('DD/MM/YYYY à HH:mm:ss')
		},
	},
	computed:{
		periods(){
			if(this.exportMode === 'month'){
				let monthsList = []
				for(var i = 1; i <= 12; i++){
					let targetMonth = moment().subtract(i, 'months')
					let startDate = targetMonth.clone().startOf('month')
					let endDate = targetMonth.clone().endOf('month')
					let label = targetMonth.format('MMMM YYYY')
					label = label.charAt(0).toUpperCase() + label.slice(1)
					monthsList.push({
						value: targetMonth.format('YYYY-MM') + '|' + startDate.format('YYYY-MM-DDTHH:mm:ss') + '|' + endDate.format('YYYY-MM-DDTHH:mm:ss'),
						label: label
					})
				}
				return monthsList
			} else {
				let weeks = []
				for(var i = 1; i < 12; i++){
					let weekMoment = moment().subtract(i,'w')
					let startDate = this.getStartDateWeek(i)
					let endDate = this.getEndDateWeek(i)
					weeks.push({
						value: weekMoment.isoWeekYear() + '-' + weekMoment.isoWeek() + '|' + startDate.format('YYYY-MM-DDTHH:mm:ss') + '|' + endDate.format('YYYY-MM-DDTHH:mm:ss'),
						label: weekMoment.isoWeekYear() + ' - Semaine ' + weekMoment.isoWeek() + ' (' + startDate.format('L') + '...)'
					})
				}
				return weeks
			}
		},
		// Le tableau affiche uniquement les fichiers du mode sélectionné
		filteredExports(){
			return this.dataExport.flat().filter(r => r.mode === this.exportMode)
		},
		tableExport(){
			this.loading = false
			const start = (this.currentPage - 1) * 10
			return this.filteredExports.slice(start, start + 10)
		},
		dataExportLength(){
			return this.filteredExports.length
		}
	},
	watch:{
		// Reset la pagination quand on change de mode
		exportMode(){
			this.currentPage = 1
		}
	},
	mounted: function(){
		this.getExportVenteSage('export','.txt')
		this.getExportPcSage('export/vente/pc','.txt')
	}
}
</script>

<style>
.iconOperationDownload{
	font-size: 1.5em;
	color: green;
}

.iconOperationCsv{
	font-size: 1.5em;
}

.iconOperationDelete{
	font-size: 1.5em;
	color: red;
}

.tabExport{
	display: flex;
    flex-direction: column;
    justify-content: center;
    width: 75%;
    align-items: center;
	margin: auto;
	padding-top: 1em;
}

.exportControls{
	display: flex;
	align-items: center;
	margin-bottom: 1em;
}

.btnGenerateCsv{
	margin-left: .5em;
}
</style>
